import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft } from "lucide-react";
import logo from "@/assets/live-stay-logo.png";
import Footer from "@/components/Footer";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/10 via-background to-secondary/10 flex flex-col">
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="text-center max-w-md mx-auto">
        {/* Logo Live Stay - usando exatamente o mesmo método do Navbar */}
        <div className="mb-8 flex justify-center">
          <img 
            src={logo} 
            alt="Live Stay" 
            className="h-20 mx-auto mb-6 object-contain"
          />
        </div>

        {/* Erro 404 */}
        <div className="mb-8">
          <h2 className="text-6xl font-bold text-primary mb-4">404</h2>
          <h3 className="text-2xl font-semibold text-gray-900 mb-2">Página não encontrada</h3>
          <p className="text-gray-600">
            A página que você está procurando não existe ou foi movida.
          </p>
        </div>

        {/* Botões de ação */}
        <div className="space-y-4">
          <Button 
            onClick={() => window.location.href = "/"}
            className="w-full gap-2"
            size="lg"
          >
            <Home className="h-5 w-5" />
            Voltar para Home
          </Button>
          
          <Button 
            onClick={() => window.history.back()}
            variant="outline"
            className="w-full gap-2"
            size="lg"
          >
            <ArrowLeft className="h-5 w-5" />
            Página Anterior
          </Button>
        </div>

        {/* Informações adicionais */}
        <div className="mt-8 text-sm text-gray-500">
          <p>Se você acredita que isso é um erro, entre em contato conosco.</p>
        </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
